import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalConfig } from '../models/modalConfig';
import { RequisitionActivityModalComponent } from 'src/app/pages/mission-control-page/requisitions-page/requisition-card/requisition-activity-modal/requisition-activity-modal.component';

@Injectable({
  providedIn: 'root'
})
export class RequisitionActivityModalService {

  requisitionActivityModal!: BsModalRef;

  constructor(private bsModalService: BsModalService) { }

  show(modalData: any): void {
    const config = new ModalConfig();
    config.class = 'custom-modal-xl custom-candidate-job-match-modal';
    config.initialState = modalData;
    config.ignoreBackdropClick = true;
    this.requisitionActivityModal = this.bsModalService.show(RequisitionActivityModalComponent, config);
  }
}
